export const ROUTES = {
  ROOT: '/settings',
};

export const UPDATE_DPD_URL = `${OPERATIONS_EDGE}/api/planning/strategy/domain/ltl-distribution`;
export const UPDATE_DPD_FORM = 'DPD';
